import { z } from "zod";
/**
 * Domain error codes. Services throw `DomainError`; exactly one place (the api's tRPC error
 * formatter) maps a code to a transport status, and the UI branches on `code` + `reason`.
 */
export const ErrorCode = z.enum([
    "not_found",
    "forbidden",
    "invalid_input",
    "conflict",
    "needs_reconnect",
    "awaiting_approval",
    "rate_limited",
    "provider_unavailable",
    "internal",
]);
export class DomainError extends Error {
    code;
    reason;
    constructor(code, reason, message) {
        super(message === undefined ? `${code}: ${reason}` : message);
        this.name = "DomainError";
        this.code = code;
        this.reason = reason;
    }
}
export function isDomainError(value) {
    return value instanceof DomainError;
}
//# sourceMappingURL=errors.js.map